import  Axios, { AxiosInstance, AxiosResponse } from 'axios';
import { IHttpClient } from './IHttpClient';
import * as Raven from "raven-js";
import { IConfig } from '../IConfig';
import { isNullOrUndefined } from 'util';

export class HttpClient implements IHttpClient {
    private axiosInstance: AxiosInstance;
    private config: IConfig;
    constructor(config: IConfig) {
        this.config = config;
        this.axiosInstance = Axios.create();
        this.axiosInstance.defaults.baseURL = config.apiBaseUrl;
        this.addResponseInterceptor();
    }
    getInstance(): AxiosInstance {
        return this.axiosInstance;
    }

    private addResponseInterceptor() {
        this.axiosInstance.interceptors.response.use(undefined, error => {
            let response: AxiosResponse = error.response;
            if (isNullOrUndefined(response)) {
                return Promise.reject(new Error("No internet connection"));
            }
            if ( response.status === 500 && !this.config.isDebug) {
                if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.password)) {
                    delete response.data.password;
                }
                if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.password1)) {
                    delete response.data.password1;
                }
                if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.confirmPassword)) {
                    delete response.data.confirmPassword;
                }
                Raven.captureException(JSON.stringify({code: 500, 
                    error: error, 
                    function: "AuthenticatedHttpClient/addResponseInterceptor",
                    response: response}));
                Raven.showReportDialog();
            }
            if (typeof response.data === "string") {
                try {
                    response.data = JSON.parse(response.data.toString());                    
                } catch (error) {
                    response.data = {
                        error: "Failed to execute request"
                    };
                }
            }
            try {
                error.message = response.data.error;                
            } catch (error) {
                error.message = "Something went wrong"; 
            }
            return Promise.reject(error);

        });
    }
}


// WEBPACK FOOTER //
// ./src/utility/HttpClient.ts